import {NgModule} from '@angular/core';
import {StaffListComponent} from './staff-list/staff-list.component';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '../../../../../../layout-components/layout.module';
import {PipesModule} from '@pipes/pipes.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {SpecialistsModule} from '@modules/specialists/specialists.module';
import {IconsModule} from '@lab365/icons';


@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        PipesModule,
        DirectivesModule,
        SpecialistsModule,
        IconsModule,
    ],
    exports: [
        StaffListComponent,
    ],
    declarations: [
        StaffListComponent,
    ],
    providers: [],
})
export class StaffListModule {
}
